import { MultiCheckboxFilterOption } from '../../../FilterResultsManager/options/types';
import { MultiSelectCheckbox } from '../../../FilterResultsManager/components';

export const config: MultiCheckboxFilterOption = {
  id: 'mutationBiochemistryContent.filters.variantClass',
  title: {
    id: 'mutationBiochemistryContent.filters.variantClass',
    defaultMessage: 'Variant Class',
  },
  content: MultiSelectCheckbox,
  injectedProps: {
    searchKey: 'impact',
    checkboxOptions: [
      {
        id: 'jaxCancerEffectContent.filters.variantClass.deletion',
        searchValue: 'deletion',
        intlLabel: {
          id: 'jaxCancerEffectContent.filters.variantClass.deletion',
          defaultMessage: 'Deletion',
        },
      },
      {
        id: 'jaxCancerEffectContent.filters.variantClass.duplication',
        searchValue: 'duplication',
        intlLabel: {
          id: 'jaxCancerEffectContent.filters.variantClass.duplication',
          defaultMessage: 'Duplication',
        },
      },
      {
        id: 'jaxCancerEffectContent.filters.variantClass.frameshift',
        searchValue: 'frameshift',
        intlLabel: {
          id: 'jaxCancerEffectContent.filters.variantClass.frameshift',
          defaultMessage: 'Frameshift',
        },
      },
      {
        id: 'jaxCancerEffectContent.filters.variantClass.fusion',
        searchValue: 'fusion',
        intlLabel: {
          id: 'jaxCancerEffectContent.filters.variantClass.fusion',
          defaultMessage: 'Fusion',
        },
      },
      {
        id: 'jaxCancerEffectContent.filters.variantClass.indel',
        searchValue: 'indel',
        intlLabel: {
          id: 'jaxCancerEffectContent.filters.variantClass.indel',
          defaultMessage: 'Indel',
        },
      },
      {
        id: 'jaxCancerEffectContent.filters.variantClass.insertion',
        searchValue: 'insertion',
        intlLabel: {
          id: 'jaxCancerEffectContent.filters.variantClass.insertion',
          defaultMessage: 'Insertion',
        },
      },
      {
        id: 'jaxCancerEffectContent.filters.variantClass.missense',
        searchValue: 'missense',
        intlLabel: {
          id: 'jaxCancerEffectContent.filters.variantClass.missense',
          defaultMessage: 'Missense',
        },
      },
      {
        id: 'jaxCancerEffectContent.filters.variantClass.none',
        searchValue: 'none',
        intlLabel: {
          id: 'jaxCancerEffectContent.filters.variantClass.none',
          defaultMessage: 'None',
        },
      },
      {
        id: 'jaxCancerEffectContent.filters.variantClass.nonsense',
        searchValue: 'nonsense',
        intlLabel: {
          id: 'jaxCancerEffectContent.filters.variantClass.nonsense',
          defaultMessage: 'Nonsense',
        },
      },
      {
        id: 'jaxCancerEffectContent.filters.variantClass.spliceSite',
        searchValue: 'splice site',
        intlLabel: {
          id: 'jaxCancerEffectContent.filters.variantClass.spliceSite',
          defaultMessage: 'Splice Site',
        },
      },
      {
        id: 'jaxCancerEffectContent.filters.variantClass.unknown',
        searchValue: 'unknown',
        intlLabel: {
          id: 'jaxCancerEffectContent.filters.variantClass.unknown',
          defaultMessage: 'Unknown',
        },
      },
    ],
  },
};
